module.exports = __webpack_public_path__ + "img/partner-game.c2ab2fbe.png";